import { axiosWithAuth } from "@/lib/AxiosClient";

export class Action {
  constructor(id: string, name: string, siteId: string, tenantId: string, featureTypeId: string | null, featureId: string | null, projectId: string | null, priorityCodeId: string, statusCodeId: string, startDate: string | null, endDate: string | null, dueDate: string | null, latitude: number | null, longitude: number | null, assignedUserId: string | null, description: string | undefined) {
    this.id = id
    this.name = name
    this.siteId = siteId
    this.tenantId = tenantId
    this.description = description
    this.featureTypeId = featureTypeId
    this.featureId = featureId
    this.projectId = projectId
    this.priorityCodeId = priorityCodeId
    this.statusCodeId = statusCodeId
    this.startDate = startDate
    this.endDate = endDate
    this.dueDate = dueDate
    this.latitude = latitude
    this.longitude = longitude
    this.assignedUserId = assignedUserId
  }

  id: string
  name: string
  siteId: string
  tenantId: string
  description: string | undefined
  featureTypeId: string | null
  featureId: string | null
  projectId: string | null
  priorityCodeId: string
  statusCodeId: string
  startDate: string | null
  endDate: string | null
  dueDate: string | null
  latitude: number | null
  longitude: number | null
  assignedUserId: string | null
  projectName: string | null = null
  assignedUserName: string | null = null
  featureName: string | null = null
  priorityCodeName: string | null = null
  attachmentUrl: string | null = null
}

export class ActionService {
  private static readonly BASE_PATH = "/api/actions"
  private static instance = axiosWithAuth;

  static async create(action: Action): Promise<Action> {
    const response = await this.instance.post<Action>(this.BASE_PATH, action);
    return response.data;
  }  

  static async getByFeatureId(featureId: string): Promise<Action[]> {
    const response = await this.instance.get<Action[]>(`${this.BASE_PATH}/list/feature/${featureId}`);
    return response.data;
  }

  static async getByFeatureTypeId(featureTypeId: string): Promise<Action[]> {
    const response = await this.instance.get<Action[]>(`${this.BASE_PATH}/featuretypes/${featureTypeId}`);
    return response.data;
  }  

  static async getByProjectId(projectId: string): Promise<Action[]> {
    const response = await this.instance.get<Action[]>(`${this.BASE_PATH}/projects/${projectId}`);
    return response.data;
  }

  static async getByAreaId(areaId: string): Promise<Action[]> {
    const response = await this.instance.get<Action[]>(`${this.BASE_PATH}/area/${areaId}`);
    return response.data;
  }

  static async getByASiteId(siteId: string): Promise<Action[]> {
    const response = await this.instance.get<Action[]>(`${this.BASE_PATH}/sites/${siteId}`);
    return response.data;
  }

  static async getById(actionId: string): Promise<Action> {
    const response = await this.instance.get<Action>(`${this.BASE_PATH}/${actionId}`);
    return response.data;
  }

  static async update(actionId: string, action: Action): Promise<Action> {
    const response = await this.instance.put<Action>(`${this.BASE_PATH}/${actionId}`, action);
    return response.data;
  }

  static async delete(actionId: string): Promise<void> {
    await this.instance.delete(`${this.BASE_PATH}/${actionId}`);
  }
}